import React from "react";
import { Alert } from "antd";

const InfoMessage = ({ message = "" }) => <Alert type="info" message={message} banner />;
export default InfoMessage;
